<template>
  <label
    :class="['file-upload', 'z-index-20-bg', dragging ? 'dragging' : '', isPanel ? 'panel' : 'fullscreen']"
    @dragenter.stop="dragging = true"
    @drop.stop.prevent="handleDrop($event)"
    @dragleave.stop="dragging = false">
    <div class="z-index-20-fg">
      <img src="../assets/image-icon.svg" />
      <span>Drop file here</span>
    </div>
  </label>
  <input ref="fileUploadInput" :multiple="multiple" :accept="fileTypes.join(',') || '*'" type="file" @change="handleFileSelect()" />
</template>

<script>
import useLeadFiles from '@/composables/useLeadFiles';

export default {
  name: 'FileUpload',
  props: {
    leadid: { type: [String, Number], default: null },
    interactionid: { type: [String, Number], default: null },
    isPanel: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    fileTypes: { type: Array, default: () => [] },
  },
  emits: ['updateFileList'],
  setup() {
    const { uploadLeadFiles } = useLeadFiles();
    return { uploadLeadFiles };
  },
  data() {
    return { dragging: false, dt: new DataTransfer() };
  },
  methods: {
    handleFileUpload() {
      if (this.isPanel || (!this.leadid && !this.interactionid)) {
        const files = [];

        for (let i = 0; i < this.$refs.fileUploadInput.files.length; i++) {
          files.push(this.$refs.fileUploadInput.files[i].name);
        }
        this.$emit('updateFileList', files);
      } else {
        this.uploadFiles();
      }
    },
    async uploadFiles(leadid, interactionid) {
      if (!this.$refs.fileUploadInput.files.length) return;
      if (!this.leadid && !leadid) return;
      await this.uploadLeadFiles(this.$refs.fileUploadInput.files, leadid || this.leadid, interactionid || this.interactionid, !this.isPanel);
      this.clearFiles();
    },
    clearFiles() {
      this.$refs.fileUploadInput.value = '';
      this.dt.items.clear();
    },
    handleDrop(e) {
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        this.dt.items.add(e.dataTransfer.files[i]);
      }
      this.dragging = false;
      this.$refs.fileUploadInput.files = this.dt.files;
      this.handleFileUpload();
    },
    handleFileSelect() {
      for (let i = 0; i < this.$refs.fileUploadInput.files.length; i++) {
        this.dt.items.add(this.$refs.fileUploadInput.files[i]);
      }
      this.dragging = false;
      this.$refs.fileUploadInput.files = this.dt.files;
      this.handleFileUpload();
    },
  },
};
</script>

<style scoped lang="scss">
.file-upload {
  &.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(239, 239, 239, 0.9);
    display: none;

    div {
      background: white;
      border: 2px dashed #4d4d4d;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50vw;
      height: 50vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      pointer-events: none;

      span {
        font-size: $fontSize20;
        color: $textColor60;
      }
    }
  }

  &.panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: $borderRadius5;
    background: rgba(239, 239, 239, 0.9);
    display: none;

    div {
      background: white;
      border: 2px dashed $inputBorderColor;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      padding-top: 4rem;
      padding-bottom: 4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      pointer-events: none;

      span {
        font-size: $fontSize20;
        color: $textColor60;
      }
    }
  }

  &.dragging {
    display: block;
  }
}

input[type='file'] {
  display: none;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
